import React, { useState } from 'react'
import TextWithTemplate from './TextWithTemplate'

function Templates() {
  const [replyContent, setReplyContent] = useState('')
  return (
    <section className="wrapper json-form">
      <div>
        <TextWithTemplate
          textContent={replyContent}
          setTextContent={setReplyContent}
          placeholder="Email message…"
          rows="5"
          className="form-control"
          style={{ marginBottom: '.5em' }}
          selectProps={{
            className: 'form-control',
          }}
          textareaLabel={<span style={{ marginBottom: '.5em' }}>Message</span>}
          selectLabel={<span style={{ marginBottom: '.5em' }}>Templates</span>}
        />
      </div>
    </section>
  )
}

export default Templates
